import { Link } from "react-router-dom";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import WhatsAppFloat from "@/components/WhatsAppFloat";
import { siteSettings } from "@/content/site";
import { ShieldCheck, ArrowRight } from "@phosphor-icons/react";

const ITEMS = [
  { t: "Impianti", d: "Copertura sugli impianti realizzati all'interno del bagno ristrutturato." },
  { t: "Prodotti installati", d: "Copertura sui prodotti forniti e installati dal nostro team." },
  { t: "Rivestimenti e posa", d: "Copertura sulla posa di piastrelle, rivestimenti e finiture." },
  { t: "Assistenza post-consegna", d: "Siamo il tuo riferimento anche dopo la fine dei lavori." },
  { t: "Gestione diretta", d: "Parli con noi, niente rimbalzi tra artigiani, fornitori e installatori." },
];

export default function SuperGaranzia() {
  return (
    <div className="bg-warm-white min-h-screen">
      <Navbar />
      <section className="section-pad">
        <div className="max-w-5xl mx-auto px-5 md:px-10">
          <div className="overline mb-4">Super Garanzia</div>
          <h1 className="font-display text-4xl md:text-6xl leading-tight mb-5">Super Garanzia Oasi: dopo la consegna non resti solo.</h1>
          <p className="text-[#5C5C59] text-base md:text-lg max-w-3xl">Un servizio pensato per darti più tranquillità anche dopo la fine dei lavori.</p>
          <p className="text-[#5C5C59] mt-6 max-w-3xl leading-relaxed">Uno dei timori più grandi quando si ristruttura è non sapere a chi rivolgersi se qualcosa non va. Con Oasi Bagni hai un unico riferimento: niente rimbalzi, niente confusione, più serenità.</p>

          <div className="mt-12 grid md:grid-cols-2 gap-5">
            {ITEMS.map((i) => (
              <div key={i.t} className="card-soft p-6">
                <ShieldCheck size={22} weight="light" className="text-oasi-green mb-3" />
                <div className="font-display text-xl mb-2">{i.t}</div>
                <div className="text-sm text-[#5C5C59] leading-relaxed">{i.d}</div>
              </div>
            ))}
          </div>

          <p className="mt-10 text-xs text-[#5C5C59] italic">I dettagli specifici della garanzia vengono sempre indicati nella proposta e nella documentazione dedicata.</p>

          <div className="mt-10 text-center">
            <Link to="/prenota-sopralluogo" className="btn-primary inline-flex items-center gap-2 px-7 py-4 rounded-full text-sm">
              Richiedi sopralluogo gratuito <ArrowRight size={16} />
            </Link>
          </div>
        </div>
      </section>
      <Footer settings={siteSettings} />
      <WhatsAppFloat number={siteSettings.whatsapp_number} />
    </div>
  );
}
